module.exports = __webpack_public_path__ + "static/media/beast.7694670a.png";